<template>
  <Teleport
    to="body"
  >
    <div class="h5-search-focus">
      <div class="header">
        <div class="input-wrapper">
          <input
            ref="inputSearchRef"
            v-model="inputValue"
            placeholder="🔍 Search anything you want"
            type="text"
          >
          <div
            @click="handleSearch"
            class="search-btn"
          >
            <Icon name="search-l" />
          </div>
        </div>
        <div
          @click="$emit('back')"
          class="cancel"
        >
          Cancel
        </div>
      </div>
      <div class="offset" />

      <div class="body">
        <img
          src="@/assets/H5/home/keyword-search.svg"
          alt=""
        >
        <div class="title-wrapper">
          <div class="title">
            Wath do you want do ...?
          </div>
          <div class="sub-title">
            🔍 Enter the description, and let’s find your treasure!
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from 'vue'
import { gaAnalytics, openURLWithChannelQuery, throttle } from '@/utils/utils'
import { fetchData } from '@/utils/fetch'
import { useStore } from 'vuex'
import { Icon } from '@/components/Icon'
import { useLanguageStore } from '@/pinia/language'

defineEmits('back')

const store = useStore()

const language = useLanguageStore()

const inputSearchRef = useTemplateRef('inputSearchRef')

const inputValue = ref('')
const lastQuery = ref('')

const productList = computed(() => store.state.productList)

watch(inputValue, (value) => {
  preSearch(value)
})

// 预调用文搜接口
const preSearch = throttle((value) => {
  if (value.length >= lastQuery.value.length) {
    lastQuery.value = value
  }
  if (value.length < lastQuery.value.length) {
    lastQuery.value = value
    return
  }

  const params = {
    async: true,
    imageId: 0,
    keyword: value,
    language: language.current,
    page: 1,
    pageSize: 20,
    region: ''
  }

  fetchData('/appb/b2b/product/searchKeyWordV2?itemNumber=50', {
    method: 'POST',
    body: JSON.stringify(params)
  })
}, 400)

const handleSearch = async () => {
  gaAnalytics('mp_search_click', 'mp_search_click')
  if (!inputValue.value) {
    return
  }
  if (location.pathname === '/') {
    localStorage.setItem('homeProductList', JSON.stringify(productList.value))
  }
  store.commit('h5Module/setSearchFoucs', false)
  openURLWithChannelQuery(`/search?keyword=${inputValue.value}`)
}

onMounted(async () => {
  await nextTick()
  if (inputSearchRef.value) {
    inputSearchRef.value.focus()
  }
  document.querySelector('body').classList.add('no-scroll')
})

onUnmounted(() => {
  document.querySelector('body').classList.remove('no-scroll')
})
</script>

<style lang="less" scoped>
.h5-search-focus {
  z-index: 1101;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: white;
  .header {
    height: 48px;
    background-color: #052784;
    padding: 0 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    .input-wrapper {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 8px;
      height: 36px;
      background-color: #fff;
      border-radius: 20px;
      border: 1.5px solid #5476d7;
      padding-right: 4px;
      input {
        flex: 1;
        height: 100%;
        border-radius: 20px;
        outline: none;
        border: none;
        padding-left: 8px;
        font-size: 12px;
        font-family: mon-500;
        &::placeholder {
          color: #b2b7c2;
        }
      }
      .search-btn {
        width: 44px;
        height: 28px;
        border-radius: 16px;
        background-color: #F57231;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: white;
      }
    }

    .cancel {
      color: white;
      font-size: 12px;
      font-family: mon-600;
    }
  }
  .offset {
    height: 8px;
    background-color: #052784;
  }

  .body {
    margin-top: 89px;
    text-align: center;

    img {
      width: 160px;
      height: 160px;
    }

    .title-wrapper {
      color: #232323;
      .title {
        font-size: 16px;
        font-family: mon-600;
        line-height: 20px;
      }
      .sub-title {
        margin-top: 8px;
        font-size: 14px;
        font-family: mon-500;
        line-height: 18px;
      }
    }
  }
}
</style>
